import produce from 'immer'
import {
  SNIPPETS_LOAD,
  SNIPPETS_LOAD_FAILURE,
  SNIPPETS_LOAD_SUCCESS
} from './actions'
import { SnippetDesignMatch } from './types'

interface SnippetsState {
  loading: boolean
  error: null | string
  data: SnippetDesignMatch[] | null
}

const initialState: SnippetsState = {
  loading: false,
  error: null,
  data: null
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SNIPPETS_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case SNIPPETS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.data
        return
      }
      case SNIPPETS_LOAD_FAILURE: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
